import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';

const CalendarExecDateField = ({
  name,
  value,
  onChange,
  error,
  helperText,
  disabled,
}) => {
  return (
    <Stack gap={1}>
      <Typography variant="body2">시작 일자</Typography>
      <TextField
        {...{ type: 'date', name, value, onChange, error, helperText }}
        disabled={disabled || false}
      />
    </Stack>
  );
};

export default CalendarExecDateField;
